import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { ClaseContingente } from '../models/claseContingente';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/ClaseContingentes';

@Injectable({
  providedIn: 'root'
})
export class ClaseContingenteService {
   
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' });
  }

  save(entidad: ClaseContingente)
  {
    return this._http.post({ url: baseUrl + '/Save', body: entidad });
  }

  delete(id: number)
  {
    return this._http.get({ url: baseUrl + '/Delete?id=' + id});
  }
}
